import React from 'react'
import PropTypes from 'prop-types'
import {
  HistoricoContainer,
  TituloHistorico,
  HistoricoItem,
  HistoricoItemTexto,
  HistoricoIcon,
  HistoricoClear,
} from '../styles'

export default function HistoricoBusca({
  listaHistorico,
  onClickHistorico,
  onClickClearHistorico,
  ...props
}) {
  return (
    <HistoricoContainer {...props}>
      <TituloHistorico>Histórico de busca</TituloHistorico>
      {listaHistorico.map((item, index) => (
        <HistoricoItem key={item.query}>
          <HistoricoItemTexto
            className="historico-item"
            onClick={() => onClickHistorico(item.query, item.categoryList)}
          >
            <HistoricoIcon name="History" />
            <span>{item.query}</span>
          </HistoricoItemTexto>
          <HistoricoClear
            className="historico-delete"
            onClick={() => onClickClearHistorico(index)}
            type="button"
          >
            <img src="/parcerias/assets/fechar.svg" alt="buscar" />
          </HistoricoClear>
        </HistoricoItem>
      ))}
    </HistoricoContainer>
  )
}

HistoricoBusca.propTypes = {
  listaHistorico: PropTypes.arrayOf(
    PropTypes.shape({
      query: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  onClickHistorico: PropTypes.func.isRequired,
  onClickClearHistorico: PropTypes.func.isRequired,
}
